/* Œuvres numériques — consentement exprès avant paiement (docs/digital-art-theme.md § Consentement).
   <digital-consent> (snippet digital-art-consent, dans le formulaire de paiement du panier ou du tiroir) : le bouton
   « Paiement » reste désactivé tant que la case n'est pas cochée ; une fois cochée, l'attribut de panier
   consentement_numerique = « texte exact | date ISO » est enregistré par /cart/update.js (et repart avec le formulaire,
   ce qui couvre un échec réseau) ; décochée, l'attribut est effacé. Chargé par les fiches numériques et par le snippet. */
(() => {
  if (customElements.get('digital-consent')) return;

  class DigitalConsent extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-consent-input]');
      this.message = this.querySelector('[data-consent-message]');
      this.submit = this.input?.form?.querySelector('[name="checkout"]');
      if (!this.input || !this.submit) return;
      this.onChange = () => this.update();
      this.input.addEventListener('change', this.onChange);
      this.sync();
    }

    disconnectedCallback() {
      this.input?.removeEventListener('change', this.onChange);
    }

    sync() {
      const given = this.input.checked;
      this.submit.disabled = !given;
      if (this.message) this.message.hidden = given;
    }

    async update() {
      const value = this.input.checked ? `${this.dataset.text} | ${new Date().toISOString()}` : '';
      if (value) this.input.value = value;
      this.sync();
      const url = this.dataset.updateUrl || window.theme?.routes?.cartUpdate || '/cart/update';
      try {
        await fetch(`${url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { consentement_numerique: value } })
        });
      } catch (e) {
        // La case cochée transmet aussi l'attribut avec le formulaire de paiement : rien à bloquer ici.
      }
    }
  }

  customElements.define('digital-consent', DigitalConsent);
})();
